import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../Services/Api";

// initialize client IP from local storage
const clientIP = localStorage.getItem('rfc_client_ip')
    ? localStorage.getItem('rfc_client_ip')
    : null

const initialState = {
    loading: false,
    data: [],
    error: ''
}

// fetch data from api
export const fetchMostTrustedToken = createAsyncThunk('fetchMostTrustedToken', async () => {
    return api
        .get(`coins/trusted?per_page=1&direction=DESC&sort_key=vote_count&ip_address=${clientIP}&page=1`)
        .then((response) => response.data.payload)
})

export const mostTrustedTokenSlice = createSlice({
    name: "mostTrustedToken",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchMostTrustedToken.pending, (state) => {
            state.loading = true
        })
        builder.addCase(fetchMostTrustedToken.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload
            state.error = ''
        })
        builder.addCase(fetchMostTrustedToken.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = action.error.message
        })
    }
});

export default mostTrustedTokenSlice.reducer